import { defineMessages } from "react-intl";

export default defineMessages({
  areYouSure: {
    id: "windows.logOut.areYouSure",
    defaultMessage: "Are you sure you want to sign out?",
    description: "",
  },
});
